module.exports = __webpack_public_path__ + "static/media/chat.bdca18dd.svg";